export const categories = [
  { slug: 'bianma-biaozhun', name: '编码标准', icon: 'ri-code-s-slash-line', description: 'H.264/AVC、H.265/HEVC、AV1 等主流编码标准深度解析', count: 8 },
  { slug: 'huazhi-youhua', name: '画质优化', icon: 'ri-image-edit-line', description: '去噪、锐化、色彩校正等画质提升技术方案', count: 6 },
  { slug: 'wusun-yasuo', name: '无损压缩', icon: 'ri-file-zip-line', description: 'FFV1、Ut Video、Lagarith 等无损编码对比评测', count: 5 },
  { slug: 'bofangqi-jianrong', name: '播放器兼容', icon: 'ri-play-circle-line', description: '多平台播放器解码能力与兼容性全面测试', count: 7 },
  { slug: 'zhizuo-liucheng', name: '制作流程', icon: 'ri-slideshow-line', description: '从拍摄到分发的完整高清无码制作工作流', count: 6 },
];

export const categoryMap: Record<string, typeof categories[number]> = {};
categories.forEach(c => { categoryMap[c.slug] = c; });